import { IEventMarketCornersHandicapFromWS } from '@/types/event';
import { BetSelection, Jollywhere } from '@/constants';
import { AbstractMarket } from '@/models/abstractMarket';

export class MarketCornersHandicapItem extends AbstractMarket {
    public handicap: string;
    public jollywhere: Jollywhere;
    public homePrice: string | null;
    public awayPrice: string | null;
    public homeBookmakerId: number | null;
    public awayBookmakerId: number | null;
    public homePriceList: [number, number][] | null;
    public awayPriceList: [number, number][] | null;
    public feedCount: number;
    public marginPerc: string | null;

    constructor(data: IEventMarketCornersHandicapFromWS) {
        super();

        this.setPreviousPrice(BetSelection.CornersHandicapHome, data.price_home_max);
        this.setPreviousPrice(BetSelection.CornersHandicapAway, data.price_away_max);

        this.homePrice = data.price_home_max;
        this.awayPrice = data.price_away_max;
        this.homeBookmakerId = data.price_home_max_site_id;
        this.awayBookmakerId = data.price_away_max_site_id;
        this.homePriceList = data.price_home_list ? JSON.parse(data.price_home_list) : null;
        this.awayPriceList = data.price_away_list ? JSON.parse(data.price_away_list) : null;
        this.handicap = data.handicap;
        this.feedCount = data.feeds_count;
        this.marginPerc = data.margin_perc;
        this.jollywhere = data.jollywhere;
    }

    public update(data: IEventMarketCornersHandicapFromWS) {
        this.setPreviousPrice(BetSelection.CornersHandicapHome, this.homePrice);
        this.setPreviousPrice(BetSelection.CornersHandicapAway, this.awayPrice);

        this.homePrice = data.price_home_max;
        this.awayPrice = data.price_away_max;
        this.homeBookmakerId = data.price_home_max_site_id;
        this.awayBookmakerId = data.price_away_max_site_id;
        this.homePriceList = data.price_home_list ? JSON.parse(data.price_home_list) : null;
        this.awayPriceList = data.price_away_list ? JSON.parse(data.price_away_list) : null;
        this.handicap = data.handicap;
        this.feedCount = data.feeds_count;
        this.marginPerc = data.margin_perc;
        this.jollywhere = data.jollywhere;
    }
}
